// extracted by mini-css-extract-plugin
export default {"button":"ArrowBackButton_button__9sVAw","icon":"ArrowBackButton_icon__8B6bu","icon_white":"ArrowBackButton_icon_white__6oxZG"};